import React, { type ReactNode, useState } from 'react'
import { Field, Form, Formik } from 'formik'

import { useAuthStore } from 'features/auth/useAuthStore'
import { Button } from 'shadcdn/ui/button'
import { Spinner } from 'ui/Spinner/Spinner'

type Props = {
  className?: string
  onSuccess?: () => void
  onClickSignUp?: () => void
  messageToUser?: ReactNode
}

export const LoginForm = React.memo((props: Props) => {
  const { onSuccess, onClickSignUp, messageToUser } = props
  const [loginError, setLoginError] = useState<string>('')

  const login = useAuthStore((state) => state.login)

  const onSubmit = async (data: { email: string; password: string }) => {
    const success = await login(data.email, data.password)
    if (!success) {
      setLoginError('Invalid email or password')
      return
    }
    onSuccess?.()
  }

  return (
    <div className="w-80">
      <h1 className="block text-2xl font-bold text-gray-800">Sign in</h1>

      <div className="mt-5">
        <Formik onSubmit={onSubmit} initialValues={{ email: '', password: '' }}>
          {({ isSubmitting }) => (
            <Form>
              <div className="grid gap-y-4">
                {messageToUser && (
                  <div className="text-sm border-l-2 bg-gray-100 p-2 px-4 rounded text-gray-600">{messageToUser}</div>
                )}
                <div>
                  <label htmlFor="email" className="block text-sm mb-2">
                    Email address
                  </label>
                  <div className="relative">
                    <Field
                      name="email"
                      type="text"
                      autoFocus={true}
                      disabled={isSubmitting}
                      className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-slate-300 focus:ring-slate-200 ring-0"
                    />
                  </div>
                  <p className="hidden text-xs text-red-600 mt-2" id="email-error">
                    Please include a valid email address so we can get back to you
                  </p>
                </div>

                <div>
                  <div className="flex justify-between items-center">
                    <label htmlFor="password" className="block text-sm mb-2">
                      Password
                    </label>
                    {/*<a*/}
                    {/*  className="text-sm text-blue-600 decoration-2 hover:underline font-medium"*/}
                    {/*  href="#"*/}
                    {/*>*/}
                    {/*  Forgot password?*/}
                    {/*</a>*/}
                  </div>
                  <div className="relative">
                    <Field
                      type="password"
                      name="password"
                      disabled={isSubmitting}
                      className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-slate-300 focus:ring-slate-200 ring-0"
                    />
                  </div>
                </div>

                {loginError && <span className="text-red-600 text-sm">{loginError}</span>}

                <Button disabled={isSubmitting}>
                  {isSubmitting && <Spinner sizeClassName="w-3 h-3 mr-1 -mt-1" />}
                  Sign in
                </Button>
              </div>

              <div className="py-3 flex items-center text-xs text-gray-400 uppercase before:flex-[1_1_0%] before:border-t before:border-gray-100 before:mr-6 after:flex-[1_1_0%] after:border-t after:border-gray-200 after:ml-6 ">
                Or
              </div>

              <p className=" text-sm text-gray-600 dark:text-gray-400 text-center">
                <a
                  className="text-slate-900 decoration-2 underline font-medium cursor-pointer"
                  onClick={() => onClickSignUp?.()}
                >
                  Sign up
                </a>
              </p>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
})
